<canvas baseChart
  [datasets]="chartData"
  [labels]="chartLabels"
  [options]="chartOptions"
  [colors]="chartColors"
  chartType="bar">
</canvas>
